import { useState } from 'react'

import { InspectionViewerType } from '~/apps/consumer/components/PartViewerModal/types'
import {
    handleRotationDegreeForInspectionDocument,
    handleZoomScale,
} from '../PartDetails/components/InspectionReport/logic'

import Carousel from './components/Carousel'

export default function InspectionViewer(props: InspectionViewerType) {
    const {
        placement,
        selectedDocdownloadUrl,
        selectedInspectionDocument,
        fictiv5sAndPhotosLength,
        fileName,
        createdAt,
        totalImagesLength,
        setInspectionDocumentIdx,
    } = props

    const [
        rotationDegreeInspectionDocument,
        setRotationDegreeInspectionDocument,
    ] = useState({
        [selectedInspectionDocument]: 0,
    })

    const [zoomScale, setZoomScale] = useState({
        [selectedInspectionDocument]: 1,
    })

    const [attachmentInputField, setAttachmentInputField] = useState(null)

    const setRotationDegree = (
        counterClockwise: boolean,
        inspectionDocumentId: number,
        rotationDegree: number,
    ) =>
        handleRotationDegreeForInspectionDocument(
            counterClockwise,
            inspectionDocumentId,
            rotationDegree,
            rotationDegreeInspectionDocument,
            setRotationDegreeInspectionDocument,
        )

    const handleZoomScaleToggle = (
        zoomIn: boolean,
        inspectionDocumentId: number,
    ) => {
        return handleZoomScale(
            zoomIn,
            inspectionDocumentId,
            zoomScale,
            setZoomScale,
        )
    }

    const prevPhoto = () => {
        if (selectedInspectionDocument > 0) {
            setInspectionDocumentIdx(selectedInspectionDocument - 1)
        }
    }

    const nextPhoto = () => {
        if (selectedInspectionDocument + 1 < totalImagesLength) {
            setInspectionDocumentIdx(selectedInspectionDocument + 1)
        }
    }

    const changeAttachmentIndex = (event: any) => {
        const idx = event.target.value - 1

        if (idx >= 0 && idx + 1 <= totalImagesLength) {
            setInspectionDocumentIdx(idx)
        }
    }

    const changeAttachmentInputField = (event: any) => {
        if (event.target.value === '') {
            setAttachmentInputField(event.target.value)
        } else {
            setAttachmentInputField(null)
            changeAttachmentIndex(event)
        }
    }

    const backDisabled = selectedInspectionDocument === 0
    const fwdDisabled = selectedInspectionDocument + 1 === totalImagesLength

    const rotationDegree =
        rotationDegreeInspectionDocument[selectedInspectionDocument] || 0
    const scale = zoomScale[selectedInspectionDocument] || 1

    return (
        <Carousel
            setRotationDegreeInspectionDocument={setRotationDegree}
            selectedInspectionDocument={selectedInspectionDocument}
            rotationDegree={rotationDegree}
            backDisabled={backDisabled}
            prevPhoto={prevPhoto}
            changeAttachmentInputField={changeAttachmentInputField}
            attachmentInputField={attachmentInputField}
            fictiv5sAndPhotosLength={fictiv5sAndPhotosLength}
            fwdDisabled={fwdDisabled}
            nextPhoto={nextPhoto}
            scale={scale}
            handleZoomScaleToggle={handleZoomScaleToggle}
            fileName={fileName}
            createdAt={createdAt}
            placement={placement}
            selectedDocdownloadUrl={selectedDocdownloadUrl}
        />
    )
}
